<!--
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2020-09-18 15:50:23
 * @Description:首页
-->
<template>
  <div class="home">
    <div class="home-content">
      <!-- banner -->
      <div class="home-content-banner">
        <div class="content-wrap">
          <div class="banner_fl">

          </div>
          <div class="banner_fr">
            <h2>{{$t('indexPage.title')}}</h2>
            <p>{{$t("indexPage.BannerTxt")}}</p>
            <div class="home-content-banner-btn" @click="joinJT">
              <span>{{$t("indexPage.BannerBtnTxt")}}</span><i class="iconfont iconxuanxianggengduojiantou"></i>
            </div>
          </div>

        </div>
      </div>
      <!-- API服务 -->
      <div class="home-content-service">
        <div class="content-wrap">
          <h3 class="title">{{$lang("API服务")}}</h3>
          <img src="@/assets/images/home/API-center.png" alt="">
          <div class="content-service-orderService pointer" @click="goAPI('/apiDoc/orderserve/create')">
            <div class="common-circle">
              <i class="iconfont iconico_shouye_dingdanfuwu"></i>
            </div>
            <div class="info-box">
              <div class="info-box-title">{{$lang("订单服务")}}</div>
              <div class="info-box-text">{{$lang("新增极兔订单")}}<br>{{$lang("了解订单实时调派状态")}}</div>
            </div>
          </div>
          <div class="content-service-track pointer" @click="goAPI('/apiDoc/logistics/query')">
            <div class="info-box" style="text-align:right">
              <div class="info-box-title">{{$lang('物流轨迹')}}</div>
              <div class="info-box-text">{{$lang('了解快件轨迹信息')}}<br>{{$lang('掌握实时进度')}}</div>
            </div>
            <div class="common-circle">
              <i class="iconfont iconico_shouye_wuliuguiji"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 业务流程 -->
      <div class="home-content-businessStep">
        <div class="content-wrap">
          <h3 class="title">{{$lang("业务流程")}}</h3>
          <div class="content-businessStep-item-box">
            <template v-for="(item,index) in businessStepList">
              <div class="content-businessStep-item" :key="index" :class="`item${index}`">
                <div class="content-businessStep-common-circle">
                  <img :src="item.imgSrc" alt="">
                </div>
                <div class="content-businessStep-title">{{$lang(item.title)}}</div>
                <div class="content-businessStep-text">{{$lang(item.text)}}</div>
              </div>
              <div class="arrow" :class="`arrow${index}`" :key="`arrow${index}`" v-if="index < 4">
                <div>
                  <i class="iconfont iconyewuliuchengjiantou"></i>
                </div>

              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- <Footer></Footer> -->
  </div>
</template>

<script type="text/javascript">
// import Footer from "./Footer";
import imgSrc1 from "@/assets/images/home/icon1.png";
import imgSrc2 from "@/assets/images/home/icon2.png";
import imgSrc3 from "@/assets/images/home/icon3.png";
import imgSrc4 from "@/assets/images/home/icon4.png";
import imgSrc5 from "@/assets/images/home/icon5.png";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  // components: {
  //   Footer,
  // },
  data() {
    return {
      businessStepList: [
        {
          title: "01.注册用户",
          text: "注册成为极兔开放平台用户",
          imgSrc: imgSrc1,
        },
        {
          title: "02.开发者认证",
          text: "填写开发者信息获取接口权限",
          imgSrc: imgSrc2,
        },
        {
          title: "03.企业认证",
          text: "填写企业信息获取全部接口权限",
          imgSrc: imgSrc3,
        },
        {
          title: "04.上线联调",
          text: "发起申请联调，测试接口性能",
          imgSrc: imgSrc4,
        },
        {
          title: "05.发布上线",
          text: "根据联调结果，进行接口上线",
          imgSrc: imgSrc5,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["user", "token"]),
  },
  methods: {
    /**
     * @description 加入极兔
     */
    joinJT() {
      if (this.user) {
        //已经登录
        this.$router.push({ path: "/control" });
      } else {
        this.$router.push({ path: "/register" });
      }
    },
    /**
     * @description 调到API文档页面
     */
    goAPI(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  font-family: PingFangSC, PingFangSC-Semibold;
}
.content-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}
.home-content-banner {
  min-width: 1200px;
  height: 720px;
  background-color: $theme-color;
  // background: $theme-color url("../../assets/images/home/banner.png") no-repeat center center;
  // background-size: 1920px 720px;
  .content-wrap {
    display: flex;
    justify-content: space-between;
    padding: 0 40px 0 30px;
    box-sizing: border-box;
  }
  .banner_fl {
    width: 500px;
    background: url("../../assets/images/register/background.png") no-repeat 0
      center;
    background-size: 100%;
  }
  .banner_fr {
    width: 580px;
    color: #ffffff;
    padding-top: 200px;
    // text-align: justify;
    box-sizing: border-box;
    h2 {
      font-size: 58px;
      font-weight: 600;
    }
    p {
      padding: 40px 0;
      font-size: 18px;
      line-height: 1.8;
    }
  }
  .home-content-banner-btn {
    height: 55px;
    border: 2px solid #ffffff;
    border-radius: 30px;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: 0 15px 0 30px;
    &:hover {
      background: #fff;
      color: $theme-color;
    }
    .iconfont {
      font-size: 19px;
      margin-left: 15px;
    }
  }
}
.home-content-service {
  height: 776px;
  text-align: center;
  padding-top: 50px;
  box-sizing: border-box;
  position: relative;
  img {
    width: 607px;
    height: 599px;
  }
  h3.title {
    font-size: 36px;
    line-height: 36px;
    font-weight: 600;
    color: #2b2d42;
    margin-bottom: 34px;
  }
  .pointer{
    display: flex;
    align-items: center;
  }
  .common-circle {
    width: 92px;
    height: 92px;
    line-height: 92px;
    background: $theme-color;
    box-shadow: 0px 6px 20px 0px rgba(230, 0, 18, 0.3);
    border-radius: 50%;
    text-align: center;
    display: inline-block;
    .iconfont {
      font-size: 52px;
      color: #fff;
    }
  }
  .info-box {
    display: inline-block;
    text-align: left;
    margin-left: 34px;
    .info-box-title {
      font-size: 24px;
      line-height: 24px;
      font-weight: 600;
      color: #2b2d42;
    }
    .info-box-text {
      font-size: 14px;
      font-weight: 400;
      color: #61666d;
      line-height: 22px;
      margin-top: 16px;
      max-width: 210px;
    }
  }
  .content-service-basicInfo {
    position: absolute;
    top: 114px;
    left: 0px;
    .info-box-text {
      width: 200px;
    }
    .common-circle {
      vertical-align: bottom;
    }
  }
  .content-service-orderService {
    position: absolute;
    top: 326px;
    left: 0px;
    .info-box {
      position: relative;
      top: 5px;
    }
  }
  .content-service-expressSheet {
    position: absolute;
    bottom: 96px;
    left: 0px;
    .info-box-text {
      width: 196px;
    }
    .common-circle {
      vertical-align: bottom;
    }
  }
  .content-service-track {
    position: absolute;
    top: 326px;
    right: 0px;
    .common-circle {
      vertical-align: bottom;
    }
    .info-box {
      margin-right: 34px;
    }
  }
  .content-service-otherServices {
    position: absolute;
    bottom: 180px;
    right: 0px;
    .info-box {
      margin-right: 34px;
    }
  }
}
.home-content-businessStep {
  // height: 620px;
  background: #f9fafc;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
  box-sizing: border-box;
  user-select: none;
  h3.title {
    font-size: 36px;
    line-height: 36px;
    font-weight: 600;
    color: #2b2d42;
  }
  .content-businessStep-common-circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin: 0 auto;
    position: relative;
    img {
      font-size: 0;
      vertical-align: middle;
      width: 100%;
      height: 100%;
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-50%,-50%)
    }
  }
  .content-businessStep-item-box {
    display: flex;
    justify-content: space-between;
    padding-top: 140px;
  }
  .content-businessStep-item {
    position: relative;
    width: 200px;
    text-align: center;
    .content-businessStep-title {
      font-size: 24px;
      font-weight: 600;
      color: #2b2d42;
      line-height: 24px;
      margin-top: 30px;
    }
    .content-businessStep-text {
      font-size: 14px;
      font-weight: 400;
      color: #61666d;
      line-height: 14px;
      margin-top: 16px;
    }
  }
  .arrow {
    color: $theme-color;
    padding-top: 41px;
    z-index: 99;
    background: #f9fafc;
    width: 26px;
    height: 26px;
    position: relative;
    .iconfont {
      font-size: 24px;
      background: #f9fafc;
    }
    &::after {
      content: "";
      position: absolute;
      height: 0;
      border-bottom: 3px dashed $theme-color;
      top: 53px;
      width: 130px;
      left: -52px;
      z-index: -1;
    }
  }
}
// rtl  排版支持
[dir="rtl"] .home-content-businessStep {
  .arrow > div {
    transform: rotate(180deg);
    right: 0;
    left: 0;
  }
}

[dir="rtl"] .home-content-banner-btn {
  padding: 0 30px 0 15px;
  .iconfont {
    transform: rotate(180deg) !important;
    margin-left: 0;
    margin-right: 15px;
  }
}
.ar,
.en {
  .banner_fr {
    h2 {
      font-size: 28px;
    }
    p {
      padding: 40px 0;
      font-size: 18px;
      line-height: 1.8;
    }
  }
}
</style>
